import React from 'react'
import Typography from '@material-ui/core/Typography'
import { toDecimalStr } from 'src/utils/toDecimal'
import { MTableBodyRow } from 'material-table'
import { useTheme } from '@material-ui/core'
import MTTable from 'src/components/MTTable'
import getOrderLineUnitCost from '../utils/getOrderLineUnitCost'
import { OrderLineItemsTableProps, OrderLineItems_expanded } from '../types'
import getOrderLineTotalCostUsd from '../utils/getOrderLineTotalCostUsd'

interface Props extends OrderLineItemsTableProps {
  loading?: boolean
  data?: OrderLineItems_expanded[]
  exchange_rate: number
  shipping_cost: number
}

export default function OrderItemsWithCosts(props: Props) {
  const { loading, data, currency_code, unit_code, revise, exchange_rate, shipping_cost, onUpdate, onDelete } = props
  const theme = useTheme()

  return (
    <MTTable
      isLoading={loading}
      data={data || []}
      columns={[
        {
          title: 'Product',
          field: 'product.name',
          editable: 'never',
          render: (rowData: any) => (
            <div style={{ width: '320px' }}>
              <Typography variant="body2">
                {rowData.product.name}
                <Typography component="span" variant="caption">
                  {rowData.size_value ? ` - ${rowData.size_value.label} ${rowData.size?.label}` : ''}
                </Typography>
              </Typography>
              <Typography style={{ color: theme.palette.grey[600] }} variant="caption">
                {rowData.pack?.name || ''}
              </Typography>
            </div>
          ),
        },

        {
          title: 'WET/MC (KG) & GROSS NET/MC (KG)',
          field: 'weight_mc',
          align: 'center',
          editable: 'never',
          render: (rowData: any) => (
            <div style={{ width: '130px' }}>
              {rowData.weight_mc} / {rowData.gross_weight}
            </div>
          ),
        },
        {
          title: 'Total MC',
          field: 'box',
          type: 'numeric',
          render: (rowData: any) => <div>{toDecimalStr(rowData.box, true)}</div>,
        },
        {
          title: 'Total NET/WET',
          field: 'net_weight_kgs',
          type: 'numeric',
          editable: 'never',
          render: (rowData: any) => toDecimalStr(rowData.weight_mc * rowData.box),
        },
        {
          title: `Total RW Price (${currency_code?.toUpperCase()}/${unit_code.toUpperCase()})`,
          field: 'raw_cost',
          type: 'numeric',
          render: (rowData: any) => toDecimalStr(rowData.raw_cost),
        },
        {
          title: `FINISHED GOODS (${currency_code?.toUpperCase()}/${unit_code.toUpperCase()})`,
          field: 'import_cost',
          type: 'numeric',
          render: (rowData: any) => <div>{toDecimalStr(rowData.import_cost)}</div>,
        },

        {
          title: `Pack Cost (${currency_code?.toUpperCase()}/${unit_code.toUpperCase()})`,
          field: 'pack_cost_baht',
          type: 'numeric',
          render: (rowData: any) => toDecimalStr(rowData.pack_cost_baht),
        },
        {
          title: `Shipping COST (USD/${unit_code.toUpperCase()})`,
          type: 'numeric',
          render: (rowData: any) => toDecimalStr(shipping_cost),
        },
        {
          title: `Unit Cost (USD/${unit_code.toUpperCase()})`,
          // field: '',
          type: 'numeric',
          editable: 'never',
          render: (rowData: any) => {
            let unit_cost_usd = getOrderLineUnitCost({
              import_cost: rowData.import_cost,
              pack_cost_baht: rowData.pack_cost_baht,
              etc_cost: revise?.exchange_rate_info.etc_cost,
              usd_export: exchange_rate,
              shipping_cost,
            })

            return toDecimalStr(unit_cost_usd)
          },
        },
        {
          title: 'Total Cost (USD)',
          // field: '',
          type: 'numeric',
          editable: 'never',
          render: (rowData: any) => {
            let unit_cost_usd = getOrderLineUnitCost({
              import_cost: rowData.import_cost,
              pack_cost_baht: rowData.pack_cost_baht,
              etc_cost: revise?.exchange_rate_info.etc_cost,
              usd_export: exchange_rate,
              shipping_cost,
            })

            let total_cost_usd = getOrderLineTotalCostUsd({
              unit_code,
              weight_mc: rowData.weight_mc,
              box: rowData.box,
              unit_cost: unit_cost_usd,
            })

            return <div style={{ width: '100px' }}>{toDecimalStr(total_cost_usd)}</div>
          },
        },
      ]}
      components={{
        Row: (props) => (
          <MTableBodyRow
            {...props}
            onRowClick={(e: any) => {
              props.actions[0]().onClick(e, props.data)
            }}
          />
        ),
      }}
      editable={{
        onRowUpdate: (newData: any, oldData: any) =>
          new Promise((resolve, reject) => {
            if (oldData.id) {
              if (onUpdate) {
                resolve(onUpdate(newData, oldData))
              }
            }
          }),
        onRowDelete: (oldData: any) =>
          new Promise((resolve, reject) => {
            if (oldData.id) {
              if (onDelete) {
                resolve(onDelete(oldData))
              }
            }
          }),
      }}
      style={{
        border: '1px solid #e3e3e3',
      }}
    />
  )
}
